export enum IntervalEndType{
  Never = 0,
  SpecificDate = 1,
  NumberOfOccurrences = 2,
  OnCondition =3
}